export function formatDate(date: string, format?: string) {
  const dateObj = new Date(date)
  
  if (format === 'europe') {
    // European format: dd/mm/yy
    const day = dateObj.getDate().toString().padStart(2, '0')
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
    const year = dateObj.getFullYear().toString().slice(-2)
    return `${day}/${month}/${year}`
  }
  
  // Default US format
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}